<!-- 交易方式 -->
<template>
  <div>
    <div class="right-item-content">
      <div class="txt-blue" style="font-size: 18px">客服热线:19272927776</div>
      <div style="margin-top: 20px">
        在官方网站、小程序或APP上，注册登录账户后，选择或搜索想要出售的卡种，输入卡号、卡密等信息，系统自动验证卡的有效性与余额。确认无误后，根据平台实时汇率计算可兑换金额，用户可选择提现至绑定的银行卡或第三方支付账户。整个过程需设置短信验证码、支付密码等多重验证环节，保障交易安全。
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: #f8f8fa;
  border-radius: 8px;
}
</style>
